import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { useAtomValue } from 'jotai';
import awsmobile from './config/aws-exports';
import './index.css';

import Main from './pages/MainPage';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider, CssBaseline } from '@mui/material';
import { buildTheme } from './styles/theme';
import { themeAtom } from './atoms/themeAtom';

Amplify.configure(awsmobile);

// テーマを themeAtom と連動させる。withAuthenticator の外側に置くことで、
// 未認証（サインイン）画面でも選択中テーマが適用される。
const ThemedRoot: React.FC = () => {
  const themeName = useAtomValue(themeAtom);
  const theme = useMemo(() => buildTheme(themeName), [themeName]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Main />
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemedRoot />
  </React.StrictMode>
);

reportWebVitals();
